import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Session } from '../models/session.model';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { User, UserType } from '../models/user.model';

@Injectable({
    providedIn: 'root'
})

export class AuthService implements CanActivate {

    private storageTokenKey = 'auth-garantor-remax';
    private userKey = 'user';

    constructor(private http: HttpClient, private router: Router) { }

    login(usuario: string, clave: string, recaptcha: string) {
        return this.http.post<Session>('/usuarios/login', { usuario, clave, recaptcha });
    }

    getLogged(): boolean {
        return !!localStorage.getItem(this.storageTokenKey);
    }

    getToken(): string | undefined {
        return localStorage.getItem(this.storageTokenKey);
    }

    saveToken(token: string) {
        localStorage.setItem(this.storageTokenKey, token);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (route.data && route.data.requireAuth === true) {
            if (this.getLogged()) {
                return true;
            }
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        } else if (route.data && route.data.requireAuth === false) {
            if (this.getLogged()) {
                this.router.navigate(['/home']);
                return false;
            }
            return true;
        } else {
            return true;
        }
    }

    logout() {
        localStorage.removeItem(this.storageTokenKey);
        localStorage.removeItem(this.userKey);
    }

    saveUser(user: User) {
        localStorage.setItem(this.userKey, JSON.stringify(user));
    }

    getUser(): User | null {
        if (localStorage.getItem(this.userKey)) {
            return JSON.parse(localStorage.getItem(this.userKey)) as User;
        } else {
            return null;
        }
    }

    requestRecovery(email: string, tipoUsuario?: UserType) {
      return this.http.post(`/usuarios/recuperacion/solicitud`, { email, tipoUsuario });
    }

    changePassword(email: string, nuevaClave: string, codigo: string) {
      return this.http.post(`/usuarios/recuperacion`, { email, nuevaClave, codigo });
    }

    changePasswordLogged(nuevaClave: string) {
      return this.http.put(`/usuarios/clave`, { nuevaClave });
    }

    changeEmail(emailActual: string, emailNuevo: string) {
      return this.http.put(`/usuarios/mail`, { emailActual, emailNuevo });
    }

    externalLogin(associateQrid: string, token: string) {
        return this.http.post<Session>('/remax/agentes/acceso', { associateQrid, token });
    }
}
